import React from 'react';
import { Button } from 'rmwc/Button';
import gtagEvent from '../../utilities/analytics/gtag-event';

import './landing-pages.css';
import '@material/button/dist/mdc.button.min.css';

const heroUri =
  'https://firebasestorage.googleapis.com/v0/b/quiver-four.appspot.com/o/marketing%2F640%2F3-supplies-5-huntnibs.jpg?alt=media&token=d9bd6e72-e9d4-466f-a48a-b12406797335';

export default (props) => {
  return (
    <article id="calligraphy-supplies-guide" className="static-landing-page" role="main">
      <section className="centered">
        <div className="row">
          <div className="hide-small">
            <img className="hero" src={heroUri} alt="Nib exemplars" />
          </div>
          <div className="flex">
            <h1 className="headline-text">Calligraphy Supplies Guide</h1>
            <p className="primary-text">Purchase from us, or source your own.</p>
            <p className="secondary-text">
              <strong>Supplies questions?</strong> <br /> Email Melissa at{' '}
              <a href="mailto:melissa@calligraphy.org?subject=Calligraphy.org Questions&body=Hey Melissa,">
                melissa@calligraphy.org
              </a>
              . She knows her calligraphy supplies.
            </p>
            <a href="https://store.calligraphy.org/collections/calligraphy-kits">
              <Button
                className="cta-button"
                raised
                onClick={() =>
                  gtagEvent('cta-click', {
                    page: 'calligraphy-supplies-guide',
                    position: 'primary',
                  })
                }
              >
                Buy Supplies Now
              </Button>
            </a>
          </div>
        </div>
      </section>
    </article>
  );
};
